// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "helcim.proto" (syntax proto3)
// tslint:disable
import { HelcimService } from "./helcim";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service HelcimService
 */
export class HelcimServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = HelcimService.typeName;
        this.methods = HelcimService.methods;
        this.options = HelcimService.options;
    }
    /**
     * @generated from protobuf rpc: CreateCheckoutSession
     */
    createCheckoutSession(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCheckoutPartialPayment
     */
    createCheckoutPartialPayment(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateVerifyCardCheckoutSession starts Helcim Pay in verify mode (amount 0) to tokenize / add a card
     * without an invoice. Use instead of CreateCheckoutSession when no invoice exists.
     *
     * @generated from protobuf rpc: CreateVerifyCardCheckoutSession
     */
    createVerifyCardCheckoutSession(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * ListCardsOnFile returns saved cards for the Kalos user from Helcim (customerCode = user_id).
     *
     * @generated from protobuf rpc: ListCardsOnFile
     */
    listCardsOnFile(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * SetPreferredHelcimCard stores the user's preferred card token so it can be surfaced in the UI.
     *
     * @generated from protobuf rpc: SetPreferredHelcimCard
     */
    setPreferredHelcimCard(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * SearchHelcimProfiles searches Helcim customer profiles (by name/email/phone) so an admin can
     * find and link an existing profile to a Kalos user. Each result carries its cards and link state.
     *
     * @generated from protobuf rpc: SearchHelcimProfiles
     */
    searchHelcimProfiles(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * LinkHelcimProfile links an existing Helcim profile to the Kalos user by setting the profile's
     * customerCode to the user_id. Blocked if the profile is already linked to a different Kalos user.
     * With relink=true, a profile already linked to THIS user is handed off instead of blocking: the
     * old profile's customerCode is neutralized (its cards are never touched) and the target takes
     * over the link.
     *
     * @generated from protobuf rpc: LinkHelcimProfile
     */
    linkHelcimProfile(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UnlinkHelcimProfile releases the user's linked profile (86bbm7wy8): the
     * profile's customerCode is neutralized (profile and cards stay intact in
     * Helcim), the preferred card tokens clear, and the profile's authorization
     * rows are deleted — consent never travels between customers.
     *
     * @generated from protobuf rpc: UnlinkHelcimProfile
     */
    unlinkHelcimProfile(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * RemoveHelcimCard deletes a saved card from the user's linked Helcim profile.
     *
     * @generated from protobuf rpc: RemoveHelcimCard
     */
    removeHelcimCard(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateHelcimEvent
     */
    createHelcimEvent(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetHelcimEvent
     */
    getHelcimEvent(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetHelcimEvent
     */
    batchGetHelcimEvent(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateHelcimEvent
     */
    updateHelcimEvent(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteHelcimEvent
     */
    deleteHelcimEvent(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * HelcimCardAuthorization is the per-card-token consent record (86bbdvay3): a card is
     * chargeable only while a row exists for its token. Nothing syncs from Helcim, so a card
     * Kalos never authorized has no row and can never be charged.
     *
     * @generated from protobuf rpc: CreateHelcimCardAuthorization
     */
    createHelcimCardAuthorization(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetHelcimCardAuthorization
     */
    getHelcimCardAuthorization(input, options) {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetHelcimCardAuthorization
     */
    batchGetHelcimCardAuthorization(input, options) {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateHelcimCardAuthorization
     */
    updateHelcimCardAuthorization(input, options) {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteHelcimCardAuthorization
     */
    deleteHelcimCardAuthorization(input, options) {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * HelcimCardAudit is the append-only audit trail for the card-on-file consent flows
     * (86bbdvb0h): search, link, relink, card save/authorize/remove, link lifecycle.
     * No Update/Delete on purpose — audit rows are immutable history.
     *
     * @generated from protobuf rpc: CreateHelcimCardAudit
     */
    createHelcimCardAudit(input, options) {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetHelcimCardAudit
     */
    getHelcimCardAudit(input, options) {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetHelcimCardAudit
     */
    batchGetHelcimCardAudit(input, options) {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Card-on-file email link lifecycle (86bav2tff). One open link per customer:
     * Create reuses an open link instead of minting a second one. The URL token is
     * stateless-encrypted, and the page renders from live card state on every
     * open, so one link covers every case and stays valid after state changes.
     *
     * @generated from protobuf rpc: CreateCardOnFileLink
     */
    createCardOnFileLink(input, options) {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCardLinkStatus
     */
    getCardLinkStatus(input, options) {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResendCardOnFileLink
     */
    resendCardOnFileLink(input, options) {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CancelCardOnFileLink
     */
    cancelCardOnFileLink(input, options) {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * AuthorizeCards records customer consent for saved cards (86bav2tff, 86bbdvb0h).
     * basis 2 (confirmation_email) sends the confirmation email and the email is the
     * consent record — a failed send authorizes nothing. basis 3 (recorded_line)
     * sends nothing; the recorded call is the record.
     *
     * @generated from protobuf rpc: AuthorizeCards
     */
    authorizeCards(input, options) {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CompleteCardSave records a staff enter-card-now save (authed counterpart of
     * CompletePublicCardSave): points the preferred token at the newest card and
     * writes the card_saved audit entry with the acting user.
     *
     * @generated from protobuf rpc: CompleteCardSave
     */
    completeCardSave(input, options) {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Public, token-gated card link page endpoints (whitelisted, unauthenticated).
     *
     * @generated from protobuf rpc: GetPublicCardLinkData
     */
    getPublicCardLinkData(input, options) {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CompletePublicCardSave
     */
    completePublicCardSave(input, options) {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PublicAuthorizeCard
     */
    publicAuthorizeCard(input, options) {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PublicRemoveCard
     */
    publicRemoveCard(input, options) {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetHelcimPlan fetches a Recurring Billing payment plan from Helcim by id.
     *
     * @generated from protobuf rpc: GetHelcimPlan
     */
    getHelcimPlan(input, options) {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetHelcimAddon fetches a Recurring Billing add-on from Helcim by id.
     *
     * @generated from protobuf rpc: GetHelcimAddon
     */
    getHelcimAddon(input, options) {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetHelcimPlanWithAddons fetches a plan and resolves every add-on referenced by addOnIds.
     *
     * @generated from protobuf rpc: GetHelcimPlanWithAddons
     */
    getHelcimPlanWithAddons(input, options) {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateSubscription enrolls a customer (customerCode = user_id) into a Helcim Recurring
     * Billing payment plan, starting the recurring charge against their default card on file.
     * payment_plan_id 0 defaults to the configured anchor plan. Membership status in Kalos is
     * tracked separately and is not touched here.
     *
     * @generated from protobuf rpc: CreateSubscription
     */
    createSubscription(input, options) {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CancelSubscription soft-cancels a Helcim subscription (PATCH status=cancelled). Billing
     * stops permanently; the subscription and its payment history remain readable in Helcim.
     *
     * @generated from protobuf rpc: CancelSubscription
     */
    cancelSubscription(input, options) {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetSubscription fetches a subscription with its per-cycle payment history, the read
     * Kalos-side reporting uses to see what Helcim actually billed (no webhooks for renewals).
     *
     * @generated from protobuf rpc: GetSubscription
     */
    getSubscription(input, options) {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * LookupPrepaidTransaction resolves a Helcim transaction id straight from Helcim and, via
     * the transaction's customerCode, the customer's active subscription. This is how a prepaid
     * enrollment confirms the payment and finds the subscription Helcim already started for an
     * online-form signup — neither fact is available from Kalos' own helcim_events rows.
     *
     * @generated from protobuf rpc: LookupPrepaidTransaction
     */
    lookupPrepaidTransaction(input, options) {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * ListCardReaders returns Helcim card-reader devices paired with the Kalos merchant.
     *
     * @generated from protobuf rpc: ListCardReaders
     */
    listCardReaders(input, options) {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * StartTerminalCapture sends a purchase request to a specific card-reader device.
     * The customer then taps/dips the card on the device. The returned helcim_event_id
     * is the row to poll via BatchGetHelcimEvent for status transitions.
     *
     * @generated from protobuf rpc: StartTerminalCapture
     */
    startTerminalCapture(input, options) {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CancelTerminalCapture cancels an in-progress card-reader capture and marks the
     * matching HelcimEvent as cancelled.
     *
     * @generated from protobuf rpc: CancelTerminalCapture
     */
    cancelTerminalCapture(input, options) {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * ChargeCardOnFile charges a saved card token through Helcim's Payment API
     * (card-not-present purchase) and records a HelcimEvent for the attempt. The
     * caller resolves which token to charge (property card, else account card);
     * the server verifies the token belongs to the customer's Helcim profile
     * before charging. Synchronous: the response carries the approved/declined
     * outcome, unlike the reader flow which is polled.
     *
     * @generated from protobuf rpc: ChargeCardOnFile
     */
    chargeCardOnFile(input, options) {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
